import AbstractCalls from "./AbstractCalls";

class VoucherCalls extends AbstractCalls {
  createMany(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "voucher/createMany");
    return AbstractCalls.post(cmdUri, dtoIn, options);
  }

  get(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "voucher/get");
    return AbstractCalls.get(cmdUri, body, options);
  }

  update(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "voucher/update");
    return AbstractCalls.put(cmdUri, dtoIn, options);
  }

  delete(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "voucher/delete");
    return AbstractCalls.delete(cmdUri, dtoIn, options);
  }

  list(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "voucher/list");
    return AbstractCalls.get(cmdUri, body, options);
  }

  verify(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "voucher/verify");
    return AbstractCalls.post(cmdUri, dtoIn, options);
  }
}

export default new VoucherCalls();
